// import React, { useEffect, useState } from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import Footer from './Homepages/Footer';
// import { Accordion } from 'react-bootstrap';
// import { Helmet } from 'react-helmet';
// import axios from 'axios';
// import parse from 'html-react-parser';


// const AboutUs = () => {

//   const[about,setAbout]=useState()
//   useEffect(()=>{
//     const fetData = async ()=>{
//       try{
//         const response = await axios('https://admin.techno-elevators.com/api/getAboutUsPageDataBySlug/about-us')
//         setAbout(response.data.data)
//       }
//       catch(err){
//         console.log(err)
//       }
//     }
//     fetData()

//   },[])
//   console.log(about)
//   return (
//     <>
// <Helmet>
// <title>About Us | Elevators & Escalators | Techno Elevators LLC </title>
// <meta name="description" content="Looking for the most reliable and efficient elevators, escalators & travelators for your offices, biulding & more? Techno elevators LLC is the perfect choice." />
// </Helmet>

//       <section className="about-page spad">
//         <Container>
//           <Row>
//             <div className='text-center mb-5 mt-5 section-title'>


//               <p className='about-heading' >{about?.about_us_section?.category_title_en}</p>
//             </div>

//             <Col lg={12} md={8}>
//               <Row className=' mb-5' >
//                 <Col lg={6}>
//                   <div className="about__page__services__text">
//                     <h5>{about?.about_us_section?.sub_category_title_en}</h5>

//                     <p>{ about?.about_us_section?.highlight_en && parse(about?.about_us_section?.highlight_en)}</p>

//                   </div>
//                 </Col>
//                 <Col lg={6}>
//                   <img src='/Images/about/about_us.jpg' width={'100%'} style={{ objectFit: "cover", height: "100%" }} />
//                 </Col>
//               </Row>
//               <div className="about__page__services">

//                 <Row className='mt-5' style={{display:"flex",justifyContent:"center"}}>

//                   {about?.our_new_vision?.sections.map((item)=>{
//                     return(

                 
//                   <Col lg={6} md={6} sm={6}>
//                     <div className="services__item">
//                       <div className='text-center'>
//                         <img className='mb-4' src={item.icon_file_or_image} alt="" width={'70px'} />
//                         <h4 className='mb-4 '>{item.section_title_en}</h4>
//                       </div>
//                       <p>{ item.description_en && parse(item.description_en)}</p>
//                     </div>
//                   </Col>
//                      )
//                     })}
                  
//                   <Col lg={12} className='mb-5' >
//                     <Row style={{ display: 'flex', justifyContent: 'center' }}>
//                       <Col lg={9}>
//                         <div>
//                           <h3 className='text-center mt-5 mb-5'>{about?.why_choose_us?.category_title_en}</h3>

//                           {about?.why_choose_us?.sections.map((item)=>{
//                             return(

                           

//                           <Accordion defaultActiveKey="0">
//                             <Accordion.Item eventKey={item.menu_id}>
//                               <Accordion.Header>
//                                 <strong>{item.section_title_en}</strong>
//                               </Accordion.Header>
//                               <Accordion.Body>
//                                 {item.description_en && parse(item.description_en)}
//                               </Accordion.Body>
//                             </Accordion.Item>


//                           </Accordion>
//                            )
//                           })}

//                         </div>

//                       </Col>
//                     </Row>

//                   </Col>

//                 </Row>
//                 <div>

//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>

      
//       <Footer />

//     </>
//   );
// };

// export default AboutUs;

import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import Footer from './Homepages/Footer';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import parse from 'html-react-parser';

const AboutUs = () => {

  const [about, setAbout] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch the About Us page data from the API
        const response = await axios('https://admin.techno-elevators.com/api/getAboutUsPageDataBySlug/about-us');
        setAbout(response.data.data); // Store the response data in state
      } catch (err) {
        console.log(err); // Log any error if the request fails
      }
    };
    fetchData();
  }, []); // The empty dependency array ensures the effect runs only once when the component mounts


  return (
    <>
      {/* Helmet for SEO purposes */}
      <Helmet>
        <title>About Us | Elevators & Escalators | Techno Elevators LLC</title>
        <meta name="description" content="Looking for the most reliable and efficient elevators, escalators & travelators for your offices, buildings & more? Techno Elevators LLC is the perfect choice." />
      </Helmet>

      {/* About Us Section */}
      <section className="about-page spad">
        <Container>
          <Row>
            {/* Section Title */}
            <div className="text-center mb-5 mt-5 section-title">
              <p className="about-heading">{about?.about_us_section?.category_title_en}</p>
            </div>

            {/* About Us Content */}
            <Col lg={12} md={8}>
              <Row className="mb-5">
                <Col lg={6}>
                  <div className="about__page__services__text">
                    <h5>{about?.about_us_section?.sub_category_title_en}</h5>
                    <p>{about?.about_us_section?.highlight_en && parse(about?.about_us_section?.highlight_en)}</p>
                  </div>
                </Col>
                <Col lg={6}>
                  <img src='/Images/about/about_us.jpg' width={'100%'} style={{ objectFit: 'cover', height: '100%' }} alt="About Us" />
                </Col>
              </Row>

              {/* Our New Vision Section */}
              <div className="about__page__services">
                <Row className="mt-5" style={{ display: "flex", justifyContent: "center" }}>
                  {about?.our_new_vision?.sections.map((item, index) => (
                    <Col lg={6} md={6} sm={6} key={index}>
                      <div className="services__item">
                        <div className="text-center">
                          <img className="mb-4" src={item.icon_file_or_image} alt={item.section_title_en} width={'70px'} />
                          <h4 className="mb-4">{item.section_title_en}</h4>
                        </div>
                        <p>{item.description_en && parse(item.description_en)}</p>
                      </div>
                    </Col>
                  ))}

                  {/* Why Choose Us Section */}
                  <Col lg={12} className="mb-5">
                    <Row style={{ display: 'flex', justifyContent: 'center' }}>
                      <Col lg={9}>
                        <div>
                          <h3 className="text-center mt-5 mb-5">{about?.why_choose_us?.category_title_en}</h3>

                          {about?.why_choose_us?.sections.map((item, index) => (
                            <Accordion key={index} defaultActiveKey="0">
                              <Accordion.Item eventKey={item.menu_id}>
                                <Accordion.Header>
                                  <strong>{item.section_title_en}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                  {item.description_en && parse(item.description_en)}
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default AboutUs;

